import React from 'react';
import EditorialTheme from './EditorialTheme';
import Header from './Header';
import Hero from './Hero';
import Features from './Features';
import AIShowcase from './AIShowcase';
import Integrations from './Integrations';
import About from './About';
import Testimonials from './Testimonials';
import Pricing from './Pricing';
import CTASection from './CTASection';
import Footer from './Footer';

const Home = () => {
  return (
    <div className="obhome" style={{ background: '#0F0B2D', color: '#111' }}>
      <EditorialTheme />
      <Header />
      <Hero />
      <Features />
      <AIShowcase />
      <Integrations />
      <About />
      <Testimonials />
      <Pricing />
      <CTASection />
      <Footer />
    </div>
  );
};

export default Home;
